<style>
.beijing{
    background-color: rgb(233, 249, 249);
}
.wodeyuyue{
    font-size: 17px !important;
    color: #009093;
}
.tubiao {
    width: 6px !important;
    height: 6px !important;
}
.xinzeng{
    margin-left: 435px;
    background-color: #009093;
    border-radius: 8px;
    font-size: 17px;
    padding: 1px 15px;
}
.yuyue_bottom{
    display: flex;
    justify-content: space-around;
    border-bottom: 1px solid gray;
}
.border_color{
    border-bottom: 1px solid gray;
}
#yingyeting .el-form-item__label{
  width: 110px !important;
}
#yingyeting .jianwidth{
  width: 300px !important;
}
#yingyeting .jianwidthhei{
  width: 500px !important;
  /* height: 200px !important; */
}
.cl_one{
  margin-top: 15px;
}
</style>
<template>
  <div id="yingyeting">
    <div class="banner-business-menu"></div>
    <div data-v-249f9abc="" class="wrapper clearfix">
      <div data-v-249f9abc="" class="content clearfix">
        <div class="main">
          <div>
            <h1>
              一键报修
            </h1>
            <div>
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="问题类型" prop="region1" class="cl_one">
                  <el-select v-model="ruleForm.region1" placeholder="请选择问题类型">
                    <el-option label="无水" value="无水"></el-option>
                    <el-option label="漏水" value="漏水"></el-option>
                    <el-option label="管道破裂" value="管道破裂"></el-option>
                    <el-option label="水表异常" value="水表异常"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="问题描述" prop="miaoshu">
                  <el-input
                   class="jianwidthhei"
                      type="textarea"
                      placeholder="请输入内容"
                      v-model="textarea"
                      maxlength="500"
                      show-word-limit
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="照片选填" prop="region3" class="jiakuan">
                  <el-upload
                    class="upload-demo"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :on-change="handleChange"
                    :file-list="fileList">
                    <el-button size="small" type="primary">点击上传</el-button>
                  </el-upload>
                </el-form-item>
                <el-form-item label="所在区域" prop="region2" class="jiakuan">
                  <el-select v-model="ruleForm.region2" placeholder="请选择区域">
                    <el-option label="东区" value="东区"></el-option>
                    <el-option label="西区" value="西区"></el-option>
                    <el-option label="南区" value="南区"></el-option>
                    <el-option label="北区" value="北区"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="联系人" prop="name">
                    <el-input v-model="ruleForm.name" class="jianwidth" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="联系方式" prop="num">
                    <el-input v-model="ruleForm.num" class="jianwidth" placeholder="请输入手机号码"></el-input>
                </el-form-item>
                <el-form-item label="联系地址" prop="dizhi">
                    <el-input v-model="ruleForm.dizhi" class="jianwidth" placeholder="请输入详细地址"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" :plain="true" @click="submitForm('ruleForm')">提交</el-button>
                  <!-- <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button> -->
                </el-form-item>
              </el-form>
              <!---->
            </div>
          </div>
        </div>
        
        
        <businessAside />
      </div>
    </div>
  </div>
</template>

<script>
import http from '../http/index'
import businessAside from '../components/aside'
export default {
  data() {
    return {
      fileList:'',
      textarea: '',
      value1:'',
      ruleForm: {
          name: '',
          num:'',
          dizhi:'',
          region1: '',
          region2: '',
          region3: '',
          miaoshu:'',
          value:'',
          resource: '',
        },
        rules: {
          name: [
            { required: true, message: '请输入联系人姓名', trigger: 'blur' },
            { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
          num: [
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            { min: 11, max: 11, message: '11位字符', trigger: 'blur' }
          ],
          miaoshu:[
            { required: true, message: '请简要叙述报修原因', trigger: 'change' }
          ],
          region1: [
            { required: true, message: '请选择问题类型', trigger: 'change' }
          ],
          region2: [
            { required: true, message: '请选择所在区域', trigger: 'change' }
          ],
          dizhi: [
            { required: true, message: '请输入详细地址', trigger: 'change' }
          ],
          resource: [
            { required: true, message: '请选择用户类型', trigger: 'change' }
          ],
        },
      year:'',
      userCode: '',
      step: 0,
      paymentMethod: '',
      eusercod:'',
      sdnijd:{}
    }
  },
  watch: {
    userCode(v) {
      console.log(v, v.length)
    },
  },
  computed:{
    years(){
      return this.year.substring(0,4)
    },
    mounth(){
      return this.year.substring(5,7)
    }
  },
  mounted() {
    console.log(this.years)
  },
  methods: {
     handleChange(file, fileList) {
        this.fileList = fileList.slice(-3);
      },
      submitForm() {
               this.$message({
          message: '提交成功,请勿重复此操作!',
          type: 'success'
        });
            },
    // submitForm(formName) {
    //     this.$refs[formName].validate((valid) => {
    //       if (valid) {
    //         alert('提交成功!');
    //       } else {
    //         console.log('error submit!!');
    //         return false;
    //       }
    //     });
    //   },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    async goPaymoney(id) {
      try {
        const res = await http.goPaymoney(id);
        this.eusercod=res[0].customercode;
        this.sdnijd=res[0];
        this.year=res[0].billmonth;
        console.log(this.years)
      } catch (ex) {
        console.log(ex);
      }
    },
    onSearchClick(){
      this.goPaymoney(this.userCode);
      this.step=1;
    },
    next() {
      if (this.step < 2) {
        this.step++
      }
    },
  },
  components: {
    businessAside,
  },
}
</script>

<style>
</style>